import {
  REQUEST_START_SIGNING,
  SUCCESS_START_SIGNING,
  FAILURE_START_SIGNING,
  CLEAR_SIGNING_STATUS
} from "./actions"

export const INIT_STATE = {
  isFetching: false,
  payload: null,
  error: null
};

export const signing = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_START_SIGNING:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_START_SIGNING:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      }
    case FAILURE_START_SIGNING:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };

    case CLEAR_SIGNING_STATUS:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: null
      };

    default:
      return state;
  }
};
